import { z } from "zod";
/**
 * Strava (`D282`): connect an account, and post a finished workout to it as
 * an activity. The Worker holds the client secret and the tokens; the app
 * never sees either.
 *
 * ── OFF UNTIL THE OWNER REGISTERS AN APP ON STRAVA ─────────────────────────
 * The Worker's `STRAVA_CLIENT_ID` var and `STRAVA_CLIENT_SECRET` secret are
 * empty until then, and `GET /me/strava` answers `available: false` — the
 * app draws no "Conectar Strava" row at all. Every other route answers 404
 * `strava.unavailable` meanwhile.
 */
export const STRAVA_ROUTES = {
    /** `GET` — whether Strava can be used, and whether this account is connected. */
    status: "/me/strava",
    /** `POST` — the Strava authorisation address to open in the browser. */
    connect: "/me/strava/connect",
    /** `GET`, public — where Strava sends the browser back with a code. */
    callback: "/strava/callback",
    /** `POST` — one finished workout, as an activity. */
    activities: "/me/strava/activities",
};
export const stravaStatusOutput = z.object({
    /** Both the client id and the secret are configured on the Worker. */
    available: z.boolean(),
    /** The Strava athlete's name, while connected. */
    athleteName: z.string().nullable().optional(),
    connected: z.boolean(),
});
export const stravaConnectOutput = z.object({
    /** Opened in the system browser; Strava returns to `callback`. */
    authorizeUrl: z.url({ protocol: /^https$/ }),
});
export const stravaActivityInput = z.strictObject({
    /** The workout's own id. The app posts each workout once; the Worker
     *  keeps no record of what it posted. */
    sessionId: z.uuid(),
    /** The activity's name, as the person reads the workout ("Treino A"). */
    name: z.string().trim().min(1).max(100),
    startedAt: z.iso.datetime(),
    endedAt: z.iso.datetime(),
    /** The device's offset from UTC at the start, in minutes (UTC-3 is
     *  -180): Strava files an activity under the athlete's LOCAL time. */
    utcOffsetMinutes: z.int().min(-840).max(840),
});
export const stravaActivityOutput = z.object({
    /** Strava's id for the activity. */
    activityId: z.string().min(1),
});
//# sourceMappingURL=strava.js.map